import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthFacade } from '../../../store/facades/auth.facade';
import { LoginRequestDTO } from '../dto/loginRequest.dto';
import { LoginResponseDTO } from '../dto/loginResponse.dto';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token: string | null | undefined;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly authFacade: AuthFacade,
    private readonly router: Router
  ) {
    this.authFacade.token$.subscribe((token) => {
      this.token = token;
    });
  }

  login(loginRequestDTO: LoginRequestDTO): Observable<LoginResponseDTO> {
    return this.httpClient.post<LoginResponseDTO>(`/v1/api/auth/token`, loginRequestDTO).pipe(
      tap(({ token }) => {
        this.authFacade.setToken(token);
        this.router.navigate(['/dashboard']);
      })
    );
  }

  logout(): void {
    this.authFacade.setToken(undefined);
    this.router.navigate(['/']);
  }
}
